import { render, staticRenderFns } from "./DxEffort.vue?vue&type=template&id=85601214&scoped=true&"
import script from "./DxEffort.vue?vue&type=script&lang=js&"
export * from "./DxEffort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85601214",
  null
  
)

export default component.exports